export default "__VITE_ASSET__eNXxhc6f__"